module.exports = __webpack_public_path__ + "img/2m.2fb7b6b1.jpg";